import React from 'react';
import { SectionReveal } from '../components/SectionReveal';
export function UrgencySection() {
  return <section className="relative w-full bg-brand-dark py-20 md:py-24 overflow-hidden" data-id="element-298">
      {/* Red accent glow */}
      <div className="absolute inset-0 bg-gradient-to-b from-brand-red/5 via-transparent to-transparent" data-id="element-299" />
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-brand-red/50 to-transparent" data-id="element-300" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 text-center" data-id="element-301">
        <SectionReveal data-id="element-302">
          <p className="text-4xl mb-4" data-id="element-303">⚠️</p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-white mb-8 uppercase" data-id="element-304">
            Cada mes que pasa…
          </h2>
        </SectionReveal>

        <SectionReveal delay={0.15} data-id="element-305">
          <div className="bg-brand-red/10 border-2 border-brand-red/30 rounded-xl p-6 md:p-8 mb-8 inline-block" data-id="element-306">
            <p className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-brand-red m-0" data-id="element-307">
              👉 seguís pagando de más.
            </p>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.25} data-id="element-308">
          <p className="text-xl sm:text-2xl text-gray-400 font-body" data-id="element-309">
            Y esa plata no vuelve.
          </p>
        </SectionReveal>
      </div>
    </section>;
}